import types from "./types";

// Certificate detail post
export const certificateData = (payload) => ({
  type: types.CERTIFICATE_DATA,
  payload,
});

export const certificateDataResponse = (payload) => ({
  type: types.CERTIFICATE_DATA_RESPONSE,
  payload,
});
export const certificateDataClear = () => ({
  type: types.CERTIFICATE_DATA_CLEAR,
});

// certifications list
export const getAllCertifications = (payload) => ({ type: types.GET_ALL_CERTIFICATIONS, payload })
export const getAllCertificationsResponse = (payload) => ({ type: types.GET_ALL_CERTIFICATIONS_RES, payload })
export const getAllCertificationsClear = () => ({ type: types.GET_ALL_CERTIFICATIONS_CLEAR })


// certification details

export const getSingleCertifications = (payload) => ({ type: types.GET_SINGLE_CERTIFICATIONS, payload })
export const getSingleCertificationsResponse = (payload) => ({ type: types.GET_SINGLE_CERTIFICATIONS_RES, payload })
export const getSingleCertificationsClear = () => ({ type: types.GET_SINGLE_CERTIFICATIONS_CLEAR })

//popular certifications

export const getPopularCertifications = (payload) => ({ type: types.GET_POPULAR_CERTIFICATIONS, payload })
export const getPopularCertificationsResponse = (payload) => ({ type: types.GET_POPULAR_CERTIFICATIONS_RES, payload })
export const getPopularCertificationsClear = () => ({ type: types.GET_POPULAR_CERTIFICATIONS_CLEAR })


//Global Search Certificates
export const getGlobalSearchCertificates = (payload) => ({
  type: types.GLOBAL_SEARCH_CERTIFICATES,
  payload,
});
export const getGlobalSearchCertificatesResponse = (payload) => ({
  type: types.GLOBAL_SEARCH_CERTIFICATES_RESPONSE,
  payload,
});
export const getGlobalSearchCertificatesClear = () => ({
  type: types.GLOBAL_SEARCH_CERTIFICATES_CLEAR,
});

